/**
 * Глобальні дії життєвого циклу записів (DAT-04, DAT-05; UX-14, UX-15; keyboard.md, розд. 1):
 * - `Ctrl+Z` / `⌘Z` поза полями — скасувати останню дію з `undo-last.ts`, поки не минуло її вікно.
 *   У полі клавіша лишається скасуванням введення браузера;
 * - команда палітри «Кошик» — кошик людини (`/trash`, trash.html, кадр В1).
 */
import { useNavigate } from '@tanstack/react-router';
import { useHotkeys } from '../app/hotkeys.ts';
import { GLOBAL } from '../app/keymap.ts';
import { shell as st } from '../i18n/uk/shell.ts';
import { TRASH_PATH } from '../shell/nav-model.ts';
import { runLastUndo } from './undo-last.ts';

export function LifecycleKeys({ signedIn }: { signedIn: boolean }) {
  const navigate = useNavigate();
  useHotkeys(
    signedIn
      ? [
          { ...GLOBAL.undoLast, label: st.undoLast, handler: () => void runLastUndo() },
          {
            label: st.trash,
            handler: () => void navigate({ to: TRASH_PATH }),
            command: { id: 'trash', group: 'nav' },
          },
        ]
      : [],
    { scope: 'global' },
  );
  return null;
}
